import Backbone from 'backbone';
import $ from 'jquery';

import SequenceSearchView, {SequenceSearchViewInitializationOptions} from 'components/SequenceSearchView';

class LibrarySearchResults extends Backbone.Collection<Backbone.Model> {
  static initClass(): void {
    this.prototype.url = '/1/api/minimal-folders';
  }
}
LibrarySearchResults.initClass();

export interface SequenceAndLibrarySearchViewOptions extends SequenceSearchViewInitializationOptions {
  selectLibrary: (library: Backbone.Model) => void;
  libraryType?: unknown;
}

class SequenceAndLibrarySearchView extends SequenceSearchView {
  selectLibrary!: (library: Backbone.Model) => void;
  libraryType!: unknown; // Appears unused - nothing ever instantiates this
  libraryResults!: LibrarySearchResults;

  override initialize(options: SequenceAndLibrarySearchViewOptions): void {
    super.initialize(options);
    const {selectLibrary, libraryType} = options;
    this.selectLibrary = selectLibrary;
    this.libraryType = libraryType;
    this.libraryResults = new LibrarySearchResults();
  }

  override updateSearchResults(): void {
    this.hideSpinner();
    this.$('.search-results').empty();
    if (this.libraryResults.length + this.sequenceResults.length === 0) {
      this.showNoResultsMessage();
      return;
    }
    const $libEls = this.libraryResults.map((library) =>
      $(
        this.resultRowTemplate({
          name: this._getLibraryLabel(library),
          path: library.get('owner_handle'),
        })
      )
        .data('result', library)
        .data('result_type', 'library')
    );
    this.$('.search-results').append($libEls);
    const $seqEls = this.sequenceResults.map((sequence) =>
      $(
        this.resultRowTemplate({
          name: sequence.get('name'),
          path: this._getSequencePath(sequence),
        })
      )
        .data('result', sequence)
        .data('result_type', 'sequence')
    );
    this.$('.search-results').append($seqEls);
    this.$('.search-results').show();
  }

  _getLibraryLabel(library: Backbone.Model): string {
    return `${library.get('name')} (folder)`;
  }

  override fetchResults(query: string): [JQueryXHR] | [JQueryXHR, JQueryXHR] {
    const data: {query: string; type?: unknown} = {query};
    if (this.libraryType) {
      data.type = this.libraryType;
    }
    const libXHR = this.libraryResults.fetch({data});
    const seqXHR = this.sequenceResults.fetch({data: {q: query}});
    return [libXHR, seqXHR];
  }

  override selectResult($target: JQuery): void {
    const targetType = $target.data('result_type');
    const targetModel = $target.data('result');
    if (this.clearSearchAfterClick) {
      this.clearSearch();
    }
    if (targetType === 'sequence') {
      this.selectSequence(targetModel);
      return;
    }
    if (targetType === 'library') {
      this.selectLibrary(targetModel);
    }
  }

  override render(): this {
    this.$el.html(this.template({searchLibrary: true}));
    if (this.alwaysDisplayResults) {
      this.showNoResultsMessage();
    }
    return this;
  }
}

export default SequenceAndLibrarySearchView;
